import { Listing } from "@/lib/types";
import PropertyAgent from "../property-details/PropertyAgent";

interface PropertySidebarProps {
  property: Listing;
}

const PropertySidebar = ({ property }: PropertySidebarProps) => {
  return (
    <div className="lg:col-span-1 space-y-6">
      {/* Agent Info - At the top */}
      <PropertyAgent
        name="Commercial Property LK"
        company="Commercial Property LK Pvt Ltd"
        email="info@commercialproperty.lk"
        phone="+94 11 234 5678"
      />

      {/* Contact Form - Removed */}
      {/* <PropertyEnquiryForm propertyId={property.id?.toString() || "0"} propertyTitle={property.title} /> */}
    </div>
  );
};

export default PropertySidebar;
